import Bowser from 'bowser';

const isBrowser = typeof window !== 'undefined' && typeof window.navigator !== 'undefined';

const browser = isBrowser ? Bowser.getParser(window.navigator.userAgent) : null;

/** 是否为移动设备 */
export const isMobile = browser ? browser.getPlatformType() === 'mobile' : false;
